import { useState } from "react";
import toast from "react-hot-toast";

export default function LockScreen({ onUnlock }) {
    const [password, setPassword] = useState("");

    const handleUnlock = () => {
        const savedPassword =
            localStorage.getItem("user_password") || "admin@123";

        if (password === savedPassword) {
            localStorage.removeItem("is_locked");   // remove lock state
            onUnlock();
            toast.success("Unlocked!");
        } else {
            toast.error("Incorrect password");
        }
    };

    return (
        <div className="fixed inset-0 bg-black/80 flex items-center justify-center z-50">
            <div className="bg-white rounded-xl p-6 w-full max-w-sm text-center shadow-xl">
                <h2 className="text-2xl font-bold mb-4">Session Locked</h2>
                <p className="mb-4">
                    You have been idle for 10 minutes. Please enter your password.
                </p>

                <input
                    type="password"
                    placeholder="Enter Password"
                    className="border p-2 w-full mb-4 rounded"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                />

                <button
                    onClick={handleUnlock}
                    className="bg-blue-600 text-white px-4 py-2 rounded w-full"
                >
                    Unlock
                </button>
            </div>
        </div>
    );
}